export default __webpack_public_path__ + "static/event-1-d2549596c9b06c221f5fc429f7f9cbb6.jpg";